export default "__VITE_ASSET__Cfm7heXt__"